export default {
	ckrxm: '持卡人姓名',
	qsrckrxm: '请输入持卡人姓名',
	ssyh: '所属银行',
	qsrssyh: '请输入所属银行',
	qrzjdyhkh: '请认真校对银行卡号，卡号错误资金将无法到账',
	qsryhkh: '请输入银行卡号',
	qrzjdkhh: '请认真校对开户行，如有错误，请手动修改',
	qsrkhhdz: '请输入开户行地址',
	qrtj: '确认添加',
	bm: '别名',
	bmnbyqfnmxd: '别名能便于区分您名下的',
	zh: '账户',
	sjhm: '手机号码',
	sjh: '手机号',
	qsrsjhm: '请输入手机号码',
	qrzjdxnbdz: '请认真校对虚拟币地址，仅支持trc20。',
	zhcwzjjwfdz: '账户错误资金将无法到账。',
	qrzjdxnbdzzhcwzjjwfdz: '请认真校对虚拟币地址，账户错误资金将无法到账。',
	qsr: '请输入',
	dz1: '地址',
	qrzjd: '请认真校对',
	zhzhcwzjjwfdd: '账户，账户错误资金将无法到账。',
	scsbqcs: '上传失败请重试',
	tj: '添加',
	tjzhcg: '添加账户成功',
	zdy: '自定义',
	z: '至',
	qx: '取消',
	qd: '确定',
	zdxq: '注单详情',
	jbxx: '基本信息',
	jsxx: '结算信息',
	tz: '投注',
	yxtz: '有效投注',
	sy: '输赢',
	zdzt: '注单状态',
	yjs: '已结算',
	wjs: '未结算',
	y1: '赢',
	s: '输',
	zdh: '注单号',
	tzsj: '投注时间',
	jssj: '结算时间',
	tjsj: '统计时间',
	sksz: '收款设置',
	jktj: '仅可添加',
	qb: '钱包',
	jzz: '加载中',
	zw: '暂无',
	qtj: '请添加',
	xz: '新增',
	tjxd: '添加新的',
	qbdz: '钱包地址',
	ts: '提示',
	nhwszqkmm: '您还未设置取款密码',
	qsz: '去设置',
	qxzqkqb: '请选择取款钱包',
	nhwbdgrxx: '您还未绑定个人信息',
	qbd: '去绑定',
	fzlj: '复制链接',
	bctp: '保存图片',
	xzcg: '下载成功',
	fxzq: '分享赚钱',
	yqlj: '邀请链接',
	ljyq: '立即邀请',
	ck: '存款',
	ckjl: '存款记录',
	zfqd: '支付渠道',
	ckje: '存款金额',
	zdje: '最大金额',
	cubz: '存款备注',
	ljck: '立即存款',
	czydwt: '充值遇到问题？',
	lxkf: '联系客服',
	jj: '解决',
	qsrckje: '请输入存款金额',
	y2: '元',
	qsrckbz: '请输入存款备注',
	ljzf: '立即支付',
	clz: '处理中',
	cg1: '成功',
	sb: '失败',
	zf: '作废',
	je: '金额',
	jysj: '交易时间',
	xq: '详情',
	zwgdjl: '暂无更多记录',
	zwsj: '暂无数据',
	wz: '未知',
	yhk: '银行卡',
	zfb: '支付宝',
	wx: '微信',
	szrmb: '数字人民币',
	ysf: '云闪付',
	szqb: '数字钱包',
	qk: '取款',
	dqxtzccxjsgytzjl: '当前系统支持查询近三个月投注记录',
	qq: 'QQ钱包',
	bmh: 'BMH充值',
	jssjbxdykssj: '结束时间必须大于开始时间',
	jzccxjsydjl: '仅支持查询近3月的记录',
	jsrqyxydqrz: '结束日期应小于当前日期',
	ye: '余额',
	zjmx: '资金明细',
	zbjl: '账变记录',
	cqjl: '存取记录',
	qhyx: '切换游戏',
	dq: '当前',
	fhzy: '返回主页',
	cxjz: '重新加载',
	zskf: '专属客服',
	tzsx: 'TZ视讯',
	cp: '彩票',
	zr: '真人',
	ty: '体育',
	dz: '电子',
	by: '捕鱼',
	qp: '棋牌',
	qsryxmcss: '请输入游戏名称搜索',
	ss: '搜索',
	qbyx: '全部游戏',
	scyx: '收藏游戏',
	whz: '维护中',
	zr1: '最热',
	rm: '热门',
	zwgdyx: '暂无更多游戏',
	qxsc: '取消收藏',
	sccg: '收藏成功',
	dsjzypm: '到手机主页屏幕',
	yxdt: '游戏大厅',
	zrsx: '真人视讯',
	cxyzqj: '畅享一掷千金',
	cggdyl: '超感官的娱乐',
	xc: '现场',
	mxycjf: '梦想一触即发',
	cpkqqj: '彩票开启奇迹',
	zjdhy: '尊敬的会员，欢迎来到天子德利！',
	qb1: '全部',
	xjye: '现金余额',
	yh: '优惠',
	tg: '推广',
	nhwdl: '您还未登录',
	dlzchck: '登录/注册后查看',
	tzgg: '通知公告',
	wzdl: '我知道了',
	jrbztc: '今日不再弹出',
	zryltytz: '真人娱乐，体育投注，电子游艺等尽在一手掌握',
	appxz: 'APP下载',
	qbyd: '全部已读',
	sx: '刷新',
	xxzx: '消息中心',
	ptgg: '平台公告',
	xttz: '系统通知',
	zy: '重要',
	zwgdtz: '暂无更多通知',
	zbxq: '账变详情',
	xjqb: '现金钱包',
	gldd: '关联订单',
	zbqye: '账变前金额',
	zbye: '账变余额',
	zbhye: '账变后余额',
	zbsj: '账变时间',
	qsrzh: '请输入账号',
	qsrmm: '请输入密码',
	wjmm: '记住密码',
	dl: '登录',
	hmyzh: '还没有账号？',
	qzc: '去注册',
	qsrdlxx: '请输入登录信息',
	qzcsrmm: '请再次输入密码',
	qsryqm: '请输入邀请码',
	bz: '币种',
	qsryzm: '请输入验证码',
	zc: '注册',
	yyzh: '已有账号，',
	qdl: '去登录',
	zccg: '注册成功',
	qsrzcxx: '请输入注册信息',
	lcmmbyz: '两次密码不一致',
	zds: '注单数',
	tzze: '投注总额',
	ljsy: '累计输赢',
	y: '月',
	r: '日',
	zyk: '总盈亏',
	yxsy: '游戏输赢',
	fsje: '返水金额',
	zdbs: '注单笔数',
	tzzl: '投注总量',
	yqfsje: '预期返水金额',
	wdfsbl: '我的返水比例',
	jr: '今日',
	yx: '游戏',
	ssfsje: '实收返水金额',
	ssfs: '实收返水',
	cg: '场馆',
	zj: '总计',
	b1: '笔',
	wdyx: '我的游戏',
	tzjl: '投注记录',
	cgyl: '场馆盈利',
	yqfs: '预期返水',
	wdqb: '我的钱包',
	yjhs: '一键回收',
	djye: '冻结余额',
	qkjl: '取款记录',
	czcg: '操作成功',
	tzxq: '通知详情',
	yhhd: '优惠活动',
	qbyh: '全部优惠',
	fllqhdxq: '福利领取活动详情',
	jthdnrjxfbg: '具体活动内容见下方表格',
	tlqlqd: 'T聊群里签到',
	zscj: '赠送彩金',
	xf: '下分',
	blsxf: '倍流水下分',
	dyt: '第1天',
	det: '第2天',
	dst: '第3天',
	dst1: '第4天',
	dwt: '第5天',
	dlt: '第6天',
	dqt: '第7天',
	mtsc100: '每天首存100元',
	hdgz: '活动规则',
	mtck: '每天存款后去群里把充值截图发群里联系群管理签到，报自己账号领取彩金.部分套利，违反本群条例会员不能参与该活动。',
	tzdl: '天子德利享有该活动的解释权和终止权，感谢您对本司的理解和支持。',
	czje: '充值金额',
	tx: '提现',
	bls: '倍流水',
	b: '倍',
	lqgz: '领取规则',
	txls: '提现流水',
	drxrczdeb: '当日新人充值第二笔',
	drxrczdsb: '当日新人充值第三笔',
	sbck: '首笔存款',
	ebck: '二笔存款',
	sdtzdldxhdhtyjb: '收到天子德利短信或电话特邀嘉宾',
	ygipzyxlqyc: '一个IP只允许领取一次。',
	bdtl: '部分套利，违反公司规则会员不给予参与。',
	bgsxysyhdjsq: '本公司享有所有活动解释权，感谢您对公司的理解和支持。',
	ygyhygid: '一个用户(一个ID)一个设备只允许领取一次。',
	jzrhtdtlhym: '禁止任何团队套利薅羊毛，若有发现违规，公司有权利取消彩金资格，扣除所有金额及禁用账号。',
	sylqcjbncycpyx: '所有领取彩金不能参与彩票游戏和三方视讯，发现直接扣彩金。',
	sdtzdldh: '收到天子德利电话和短信的特邀嘉宾于活动开启后，每日前两笔存款，都以享受赠送优惠。',
	ghdbyrhsb: '该活动不与任何首笔，首存，复存优惠活动共享。',
	rjfyljyj: '日结负盈利救援金',
	drfyl: '当日负盈利',
	crfylflcj: '次日负盈利反利彩金',
	zcr2330: '注：次日23：30分前未申请则视为自动放弃申请',
	yhsyd: '用户受到邀请的电话号码绑定游戏账号的会员，当日参与游戏产生负盈利总和，次日上午10点后，联系专线客服经理，上报主管审核后给与办理。',
	drsyyx: '当日所有游戏负盈利产生后次日上午10：00点后，联系专线客服经理给与办理。',
	dhhdx: '电话或短信特邀客人凡是介绍客户加我们聊天软件，下载APP注册成功',
	sc200: '首存200元，反介绍人38元彩金，5倍流水即可体现。',
	hymccz: '会员每次充值满足以下条件，均可参与“领取彩金”',
	dbckje: '单笔存款金额',
	tkls: '提款流水',
	jzrhgr: '禁止任何个人和团队薅羊毛，否则后果自行承担。',
	chdbcy: '此活动不参与三方视讯和彩票游戏，发现直接扣除彩金赠送。',
	bgsxyhdjsq: '本公司享有活动解释权，与终止权！',
	usdtcz: 'USDT充值每笔充值均可赠送1%',
	yq500: '500元起',
	czdzjk: '充值到账即可咨询客服领取赠送金额',
	czdzxdysj: '充值到账需第一时间咨询客服领取，如游戏之后不计。',
	sylqcjbncysfsx: '所有领取彩金不能参与三方视讯、彩票、开元棋牌，发现直接扣除彩金。此活动不和别的活动叠加。',
	fcc: '复存冲',
	activity_l01: '天子德利开业前15天签到活动',
	activity_l02: '新人首充有好礼',
	activity_l03: '新人复存两重礼',
	activity_l04: '次日前两笔存款好礼',
	activity_l05: '日结负盈利救援金',
	activity_l06: '介绍客户',
	activity_l07: '每次充值均送彩金',
	activity_l08: 'USDT充值每笔充值均可赠送1%',
	activity_l09: '新人首充有好礼',
	activity_l10: '复存好礼',
	jyxq: '交易详情',
	jylx: '交易类型',
	jyfs: '交易方式',
	zt: '状态',
	ddhm: '订单号码',
	bdzl: '绑定资料',
	zsxm: '真实姓名',
	qsrzsxm: '请输入真实姓名',
	qh: '区号',
	bdcg: '绑定成功',
	szdlmm: '设置登录密码',
	ymm: '原密码',
	qsrydlmm: '请输入原登录密码',
	xmm: '新密码',
	qsrxdlmm: '请输入新登录密码',
	qrmm: '确认密码',
	qzcsrxdlmm: '请再次输入新登录密码',
	xgcg: '修改成功，即将返回登录',
	sz: '设置',
	xg: '修改',
	qkmm: '取款密码',
	qsryqkmm: '请输入原取款密码',
	qsrxqkmm: '请输入新取款密码',
	qzcsrxqkmm: '请再次输入新取款密码',
	edzh: '额度转换',
	zcyx: '转出游戏',
	zryx: '转入游戏',
	w: '我',
	dt: '天子德利大厅',
	hyzh: '会员账号',
	qhzh: '切换账号',
	zd: '注单',
	yk: '盈亏',
	aqzx: '安全中心',
	ryqtyw: '如有其他疑问或建议，请',
	qh1: '切换',
	dbqk: '单笔取款',
	qsrqkmm: '请输入取款密码',
	ljqk: '立即取款',
	rxbzq: '如需帮助 请',
	gl: '管理',
	qkcg: '取款成功',
	nhwbdshhxm: '您还未绑定手机和姓名',
	nhwdlqdl: '您还未登录，请登录',
	zwkf: '暂未开放',
	fzcg: '复制成功',
	zwzxkf: '暂无在线客服',
	xz1: '选择',
	xxcqk: '线下存取款',
	xjcqk: '现金存取款',
	cmcqk: '筹码存取款',
	xsck: '线上存款',
	xsqk: '线上取款',
	bk: '补扣',
	zf1: '转分',
	hd: '活动',
	yj: '佣金',
	fs: '返水',
	js: '结算',
	wx1: '无效',
	cx: '撤销',
	zz: '转账',
	j2r: '近2日',
	j7r: '近7日',
	j30r: '近30天',
	wcl: '未处理',
	dj: '电竞',
	jj1: '街机',
	sx1: '视讯',
	yqx: '已取消',
	syzd: '所有注单',
	zczd: '正常注单',
	cszd: '重算注单',
	yzfs: '验证方式',
	wbhndzhaq: '为保护您的账户安全，建议开启验证方式。',
	ybd: '已绑定',
	bd: '绑定',
	dlmm: '登录密码',
	qsrymm: '请输入原密码',
	qsrxmm: '请输入新密码',
	szcg: '设置成功',
	ndfsbl: '您的返水比例由您的上级代理制定。',
	rgndsjdl: '如果您的上级代理调整了该比例，将实时生效。',
	ndqd: '您当前的返水比例为',
	zdl: '知道了',
	yy: '语言',
	tcdl: '退出登录',
	dqbb: '当前版本',
	qrtcdl: '确认退出登录？',
	1157: "获取比例失败",
	1158: "账号不能登录本平台",
	1159: "获取失败",
	1160: "URL不合法",
	1161: "设置权限错误",
	1162: "获取权限出错",
	1163: "已经绑定",
	1164: "代付失败",
	1165: "已绑定谷歌验证器",
	1166: "绑定失败",
	1167: "谷歌验证码错误",
	1168: "获取失败",
	1169: "用户被禁用",
	1170: "设置失败",
	1172: "订单由代付接管",
	1173: "默认洗码比例错误",
	1174: "获取失败",
	1175: "更新游戏位置失败",
	1176: "删除失败",
	1177: "获取数据失败",
	1178: "操作失败",
	1179: "查询失败",
	1180: "已收藏",
	1181: "设置失败",
	1182: "获取限红模板失败",
	1183: "设置限红模板失败",
	1184: "删除失败",
	1185: "时间间隔不能超过一天",
	1186: "登录次数超限",
	1187: "请输入合法的收款地址",
	2001: "下单失败",
	2002: "回调出错",
	2003: "回调签名验证失败",
	2004: "金额超过范围",
	2005: "获取汇率失败",
	2006: "线上充值,回调成功,上分流程失败",
	2007: "支付平台状态错误",
	2008: "获取支付渠道失败",
	2009: "支付编码错误",
	2010: "回调ip错误",
	2011: "未支付订单超过限制",
	2012: "渠道不存在",
	2013: "渠道被禁用",
	2014: "渠道配置金额错误",
	2015: "支付配置错误",
	2016: "提现回调失败",
	2017: "提现反查失败",
	2018: "结算期间不能修改",
	2019: "不能小于下级",
	4403: "刷新令牌失败",
	1117: "时间格式错误",
	1118: "开始时间必须小于结束时间",
	1119: "查询间隔不能超过1个月",
	1120: "获取游戏列表失败",
	1121: "没有修改任何信息",
	1122: "查询失败",
	1123: "查询失败",
	1124: "获取排行失败",
	1125: "不能操作自己",
	1126: "操作失败",
	1127: "ip已经存在",
	1128: "添加失败,请联系管理员",
	1129: "删除失败",
	1130: "IP非法",
	1131: "获取失败",
	1132: "结算重复",
	1133: "操作失败,请联系管理员",
	1134: "操作失败,请联系管理员",
	1135: "获取配置信息失败",
	1136: "登录失败",
	1137: "最低提款金额500",
	1138: "绑定失败",
	1139: "查询失败",
	1140: "查询失败",
	1141: "流水不足",
	1142: "获取收款账号信息失败",
	1143: "存款操作失败",
	1144: "查询失败",
	1145: "操作失败",
	1146: "游戏标签标错",
	1147: "获取场馆信息失败",
	1148: "获取信息失败",
	1149: "获取报表失败",
	1150: "获取失败",
	1151: "获取优惠活动失败",
	1152: "获取支付标签失败",
	1153: "上传失败",
	1154: "修改失败",
	1155: "上级未设置",
	1156: "不能大于上级",
	1157: "子账号不能此操作",
	1057: "财务处理失败",
	1063: "汇款失败,财务审核只能作废",
	1064: "汇款处理失败",
	1065: "获取订单失败",
	1066: "获取订单失败",
	1067: "获取财务提醒失败",
	1068: "获取汇款提醒失败",
	1069: "请先设置取款密码", // 注意重复，后定义的覆盖前面的
	1070: "登陆失败!!!请联系管理员!!!",
	1071: "邀请码错误",
	1072: "获取订单失败",
	1073: "电子占成比不能大于上级", // 同样有重复
	1074: "双边洗码比不能大于上级",
	1075: "创建试玩用户失败，请稍后重试!!!",
	1076: "账号创建成功,权限初始化失败,请联系管理员!!!",
	1077: "获取失败",
	1078: "未查询到数据",
	1079: "未查询到数据",
	1080: "刷新失败",
	1081: "获取失败",
	1082: "获取签名失败",
	1083: "获取公告失败",
	1084: "结算失败",
	1085: "余额不足无法结算",
	1086: "查询失败",
	1087: "登陆失败",
	1088: "获取游戏列表失败",
	1089: "额度转换失败",
	1090: "余额不足",
	1091: "平台错误",
	1092: "电游洗码不能超过上级",
	1093: "结算失败",
	1094: "未查询到数据",
	1095: "开始时间格式错误",
	1096: "结束时间格式错误",
	1097: "开始时间不能大于结束时间",
	1098: "结算金额为0",
	1099: "结束时间不能大于当前时间",
	1100: "获取配置出错",
	1101: "查询报表失败",
	1102: "获取下级失败",
	1103: "获取失败",
	1104: "获取失败",
	1105: "获取失败",
	1106: "操作失败",
	1107: "平台不存在",
	1108: "平台上账号不存在",
	1109: "查询失败",
	1110: "操作失败",
	1111: "额度转换失败",
	1112: "获取失败",
	1113: "获取失败",
	1114: "结算金额大于佣金",
	1115: "踢出游戏失败",
	1116: "获取游戏配置失败",
	1: "查询错误", // -1 有重复，保留最后一个
	2: "暂未开放接口",
	3: "请勿频繁请求",
	4: "修改失败",
	5: "游戏维护中",
	6: "平台创建账号失败",
	7: "平台未开放",
	8: "游戏不存在",
	1002: "用户不存在",
	1003: "用户名密码错误",
	1004: "生成令牌失败",
	1005: "原密码错误",
	1006: "修改失败",
	1007: "获取账号状态失败",
	1008: "mysql错误",
	1010: "创建账号失败",
	1011: "账号已经存在",
	1012: "未查询到用户信息",
	1013: "不要操作自己",
	1014: "余额不足",
	1015: "操作失败",
	1016: "操作类型错误",
	1017: "修改账号失败",
	1018: "获取在线投注列表失败",
	1019: "账号不存在",
	1020: "未查询到数据",
	1021: "未查询到记录",
	1022: "查询出错",
	1023: "账号不存在",
	1024: "查询失败",
	1025: "未查询到数据",
	1026: "获取菜单失败",
	1027: "获取菜单失败",
	1028: "修改菜单失败",
	1029: "账号在其他地方登陆",
	1030: "密码已更改请重新登录",
	1031: "权限不足",
	1032: "验证码错误",
	1033: "登录用户出错",
	1036: "父账号不存在",
	1037: "获取在线列表失败",
	1038: "操作失败",
	1039: "银行卡用户名不一致",
	1040: "添加银行卡失败",
	1041: "银行卡号已经存在",
	1042: "删除银行卡失败",
	1043: "金额不正确",
	1045: "操作成功!!!通知玩家失败,请玩家重新登陆游戏!",
	1046: "账号只能包含6-20位数字和字母",
	1047: "获取手机验证码错误",
	1049: "用户只有一张银行卡不能删除",
	1050: "删除失败",
	1051: "修改取款密码失败",
	1052: "原密码错误",
	1053: "获取失败",
	1054: "设置取款密码失败",
	1055: "用户已设置取款密码",
	1056: "提款失败",
	wlcwqcs:'网络错误，请重试',
	jyfbsyjm:'基于分布式云加密的虚拟币系统全面保障您的资金安全',
	zffs:'支付方式',
	bqsy:'版权所有 2024版权所有',
	jrsjsy:'今日实际输赢',
	jryxtze:'今日有效投注额',
	gdyx:'更多游戏',
	sjsmxz:'手机扫描下载',
	sjksfw:'手机快速访问',
	sy1:'首页',
	kf:'客服',
	App:'App',
	wjmm1:'忘记密码？',
	qsrdlzhhmm:'请输入登录账号和密码',
	qsrzczh:'请输入注册账号',
	qqrmm:'请确认密码',
	qxz:'请选择',
	yyzh1:'已有账号',
	sjtj:'数据统计',
	wdfs:'我的返水',
	xzapp:'下载App',
	zxkf:'在线客服'
}